import { Alert, Avatar, Button, InputNumber, Modal, Space, Typography } from 'antd';
import React from 'react';

const { Title, Text } = Typography;

const colors = {
    primary: '#242166',
    light: '#f0f2f5',
};

const TauxCommissionsAgenceModal = ({
    open,
    onClose,
    categories = [],
    commissionValues = {},
    setCommissionValues,
    onSave,
    saving = false,
    canEditRates = true,
    agence,
}) => {
    const handleCommissionValueChange = (codeCategorie, value) => {
        setCommissionValues((prev) => ({
            ...prev,
            [codeCategorie]: value ?? 0,
        }));
    };

    return (
        <Modal
            open={open}
            onCancel={onClose}
            footer={null}
            width={720}
            centered
            destroyOnClose
        >
            <div className="text-center mb-4">
                <Title level={4} style={{ marginBottom: 0 }}>Gestion des taux de commission</Title>
                <Text type="secondary">
                    Définissez les taux de commission pour{' '}
                    <b>{agence?.nom || 'cette agence'}</b>
                </Text>
            </div>

            <div style={{ maxHeight: '55vh', overflowY: 'auto', paddingRight: 8 }}>
                {categories.map((cat) => (
                    <div
                        key={cat.codeCategorie}
                        style={{
                            border: '1px solid #f0f0f0',
                            borderRadius: 12,
                            padding: 16,
                            marginBottom: 12,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Space align="start">
                            <Avatar shape="square" size={40} style={{ background: colors.light, color: colors.primary }}>
                                {cat.codeCategorie?.charAt(0)}
                            </Avatar>
                            <div>
                                <Text strong>{cat.nom}</Text>
                                <div>
                                    <Text type="secondary">{cat.codeCategorie}</Text>
                                </div>
                            </div>
                        </Space>
                        <Space>
                            <InputNumber
                                min={0}
                                precision={2}
                                value={commissionValues?.[cat.codeCategorie] ?? 0}
                                disabled={!canEditRates}
                                onChange={(value) => handleCommissionValueChange(cat.codeCategorie, value)}
                                style={{ width: 120 }}
                            />
                            <Text strong>%</Text>
                        </Space>
                    </div>
                ))}
            </div>

            <Alert
                type="info"
                showIcon
                message={canEditRates ? "Les modifications seront appliquées immédiatement après enregistrement." : "Mode lecture seule : les taux sont visibles mais non modifiables."}
                style={{ marginTop: 16 }}
            />

            <Space style={{ width: '100%', justifyContent: 'flex-end', marginTop: 16 }}>
                <Button onClick={onClose}>{canEditRates ? 'Annuler' : 'Fermer'}</Button>
                {canEditRates && (
                    <Button type="primary" onClick={onSave} loading={saving}>
                        Enregistrer les taux
                    </Button>
                )}
            </Space>
        </Modal>
    );
};

export default TauxCommissionsAgenceModal;
